import { render, staticRenderFns } from "./GerarPreFaturaDespesaAgregadoDetalhes.vue?vue&type=template&id=2a15882d"
import script from "./GerarPreFaturaDespesaAgregadoDetalhes.vue?vue&type=script&lang=js"
export * from "./GerarPreFaturaDespesaAgregadoDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports